import { IActiveCountryMap } from 'interfaces';
import React from 'react';
import { FGStack, FGTypography } from '@fg/design-system';
import RightArrow from 'assets/svg/arrow_right.svg?react';
import rootStore from 'RootStore';
import { map, isEmpty } from 'lodash/fp';
import { LegendCircle, LegendLabel } from './SortLegendComponents';

type Props = {
    selectedCountries?: number[];
    licencedCountries?: IActiveCountryMap;
};

export const SortByRiskLegend = React.memo(
    ({ selectedCountries, licencedCountries }: Props) => {
        return (
            <div style={{ marginTop: 37, marginBottom: 48, marginLeft: 8 }}>
                <FGStack
                    alignItems="center"
                    gap={8}
                    style={{ flexWrap: 'wrap' }}>
                    <LegendCircle radius={32} />
                    <LegendLabel>High (100)</LegendLabel>
                    <RightArrow />
                    <LegendCircle radius={16} />
                    <LegendLabel>Low (0)</LegendLabel>
                    <LegendCountries
                        selectedCountries={selectedCountries}
                        licencedCountries={licencedCountries}
                    />
                </FGStack>
            </div>
        );
    }
);

type LegendCountriesProps = {
    selectedCountries?: number[];
    licencedCountries?: IActiveCountryMap;
};

const LegendCountries = React.memo(
    ({ selectedCountries, licencedCountries }: LegendCountriesProps) => {
        if (isEmpty(selectedCountries)) {
            return null;
        }
        return (
            // React.Fragment is used to keep the parent flex-wrap wrapping multiline correctly
            <React.Fragment>
                <div
                    style={{
                        marginInline: 24,
                        fontSize: 8,
                        color: 'var(fg-color-border);',
                    }}>
                    |
                </div>
                {map(countryId => {
                    return (
                        <FGStack
                            alignItems="center"
                            // the legend container (which also includes the initial circles) has a 8px gap,
                            // but the countries should have 16px gap
                            style={{ marginRight: 8 }}
                            key={countryId}
                            gap={8}>
                            <LegendCircle
                                radius={12}
                                bg={rootStore.countryStore.colorStack.color(
                                    countryId
                                )}
                            />
                            <FGTypography
                                variant="captions"
                                tag="label"
                                color="strong">
                                {licencedCountries[countryId]?.name}
                            </FGTypography>
                        </FGStack>
                    );
                }, selectedCountries)}
            </React.Fragment>
        );
    }
);
